import {
  KEY_ARTICLES_WP,
  KEY_PRACTICE_AFFIRMATIONS,
  KEY_PRACTICE_AFFIRMATIONS_WP,
  KEY_PRACTICE_BREATHWORK,
  KEY_PRACTICE_BREATHWORK_WP,
  KEY_PRACTICE_COMPLIMENTS,
  KEY_PRACTICE_COMPLIMENTS_WP,
  KEY_PRACTICE_COPING_SKILLS,
  KEY_PRACTICE_COPING_SKILLS_WP,
  KEY_PRACTICE_DAILY_REMBLE,
  KEY_PRACTICE_DAILY_REMBLE_WP,
  KEY_PRACTICE_DATE_IDEAS,
  KEY_PRACTICE_DATE_IDEAS_WP,
  KEY_PRACTICE_JOURNALING,
  KEY_PRACTICE_JOURNALING_WP,
  KEY_PRACTICE_MEDITATIONS,
  KEY_PRACTICE_MEDITATIONS_WP,
  KEY_PRACTICE_RELATIONSHIPQA,
  KEY_PRACTICE_RELATIONSHIPQA_WP,
  KEY_PREFERENCE_AFFIRMATIONS,
  KEY_PREFERENCE_BREATHWORK,
  KEY_PREFERENCE_COPING_SKILLS,
  KEY_PREFERENCE_JOURNALING,
  KEY_PREFERENCE_MEDITATIONS,
  KEY_PREFERENCE_RELATIONSHIPQA
} from '.'

import {
  ROUTE_ACTIVITIES_AFFIRMATIONS_ALL,
  ROUTE_ACTIVITIES_JOURNALING_ALL,
  ROUTE_ACTIVITIES_BREATHING_ALL,
  ROUTE_ACTIVITIES_COPINGSKILLS_ALL,
  ROUTE_ACTIVITIES_RELATIONSHIPQA_ALL,
  ROUTE_ACTIVITIES_MEDITATION_ALL,
  ROUTE_ACTIVITIES_COMPLIMENTS_ALL,
  ROUTE_ACTIVITIES_DATE_IDEAS_ALL,
  ROUTE_DAILY_REMBLE,
  ROUTE_COURSES_ALL,
  ROUTE_ARTICLES_BASE
} from '../helpers/Paths'

// Thumbnails/previews
import AffirmationImage from '../../../assets/images/practices/preview-affirmations.jpeg'
import BreathworkImage from '../../../assets/images/practices/preview-breathwork.jpeg'
import CopingSkillsImage from '../../../assets/images/practices/preview-coping-skills.jpeg'
import JournalingImage from '../../../assets/images/practices/preview-journaling.jpeg'
import MeditationImage from '../../../assets/images/practices/preview-meditations.jpeg'
import RelationshipQAImage from '../../../assets/images/practices/preview-relationship-conversations.jpeg'
import DateIdeasImage from '../../../assets/images/practices/preview-date-ideas.jpg'
import ComplimentsImage from '../../../assets/images/practices/preview-compliments.jpg'
import { LMS_TYPE_COURSES, LMS_TYPE_TOPIC } from './Courses'

export const LMSKeys = {
  [KEY_PRACTICE_DAILY_REMBLE_WP]: {
    title: 'Daily Remble',
    showInSearch: true,
    showInChat: true,
    path: ROUTE_DAILY_REMBLE,
    order: 1
  },
  [LMS_TYPE_COURSES]: {
    title: 'Courses',
    showInSearch: true,
    showInChat: true,
    path: ROUTE_COURSES_ALL,
    order: 2
  },
  [LMS_TYPE_TOPIC]: {
    title: 'Sessions',
    showInSearch: false,
    showInChat: false,
    path: '/courses/:courseId/lessons/:lessonId/topics',
    order: 3
  },
  [KEY_PRACTICE_AFFIRMATIONS_WP]: {
    title: 'Affirmations',
    showInSearch: false,
    showInChat: false,
    isCategory: true
  },
  [KEY_PRACTICE_BREATHWORK_WP]: {
    title: 'Breathwork',
    showInChat: true,
    showInSearch: true,
    order: 4
  },
  [KEY_PRACTICE_COPING_SKILLS_WP]: {
    title: 'Coping Skills',
    showInSearch: true,
    showInChat: true,
    order: 5
  },
  [KEY_PRACTICE_JOURNALING_WP]: {
    title: 'Daily Journals',
    showInSearch: false,
    showInChat: false
  },
  [KEY_PRACTICE_JOURNALING]: {
    title: 'Journaling Prompts',
    isCategory: true,
    showInSearch: false,
    showInChat: false
  },
  [KEY_PRACTICE_RELATIONSHIPQA_WP]: {
    title: 'Relationship Conversations',
    isCategory: true,
    showInSearch: false,
    showInChat: false
  },
  [KEY_PRACTICE_MEDITATIONS_WP]: {
    title: 'Meditations',
    showInSearch: true,
    order: 6
  },
  [KEY_PRACTICE_DATE_IDEAS_WP]: {
    title: 'Date Ideas',
    showInSearch: false,
    showInChat: false,
    isCategory: true
  },
  [KEY_PRACTICE_COMPLIMENTS_WP]: {
    title: 'Compliments',
    showInSearch: false,
    showInChat: false,
    isCategory: true
  },
  [KEY_ARTICLES_WP]: {
    title: 'Articles',
    showInSearch: true,
    showInChat: true,
    path: ROUTE_ARTICLES_BASE
  }
}

export const practices = [
  {
    active: true,
    key: KEY_PRACTICE_AFFIRMATIONS,
    lmsType: KEY_PRACTICE_AFFIRMATIONS_WP,
    preferenceKey: KEY_PREFERENCE_AFFIRMATIONS,
    title: 'Affirmations',
    path: ROUTE_ACTIVITIES_AFFIRMATIONS_ALL,
    image: AffirmationImage,
    why: {
      author: 'Jordan Green',
      bio: 'Jordan is an individual and couples therapist, creator of @the.love.therapist Instagram account, and founder of Remble.',
      title: 'Affirmations',
      authorImage:
        'https://media-private.remble.com/wp-content/uploads/Jordan.png',
      subtitle:
        'Hundreds of brief, powerful statements that help you overcome self-defeating and negative thoughts, boost your confidence, and encourage you to think optimistically. Or get Mia’s help to create your own.',
      content:
        '<ul> <li>What are affirmations?</li> <li>The science of affirmations</li> <li>The benefits of daily affirmations</li> </ul>',
      videoURL:
        'https://media-private.remble.com/tutorials/videos/about_remple_affirmations.mp4',
      captionsURL:
        'https://media-private.remble.com/tutorials/captions/about_remple_affirmations_text.vtt'
    },
    description:
      'Affirmations are positive phrases you repeat daily that help you overcome negative thoughts or worries and enhance self-confidence and self-esteem.'
  },
  {
    active: true,
    hasIntro: true,
    key: KEY_PRACTICE_BREATHWORK,
    lmsType: KEY_PRACTICE_BREATHWORK_WP,
    preferenceKey: KEY_PREFERENCE_BREATHWORK,
    title: 'Breathwork',
    path: ROUTE_ACTIVITIES_BREATHING_ALL,
    image: BreathworkImage,
    why: {
      author: 'Jordan Green',
      bio: 'Jordan is an individual and couples therapist, creator of @the.love.therapist Instagram account, and founder of Remble.',
      title: 'Breathwork',
      authorImage:
        'https://media-private.remble.com/wp-content/uploads/Jordan.png',
      subtitle:
        'Tap into the power of your breath with guided video practices to achieve an elevated state of awareness, clarity, healing, and peace. Or get Mia’s help to create your own.',
      content:
        '<ul> <li>What is Breathwork?</li> <li>The science of breathing</li> <li>The benefits of daily breathing</li> </ul>',
      videoURL:
        'https://media-private.remble.com/tutorials/videos/about_breathwork.mp4',
      captionsURL:
        'https://media-private.remble.com/tutorials/captions/about_breathwork_text.vtt'
    },
    description:
      'Breathwork involves mindful control of your breath to achieve relaxation, worry less, and relieve anxiety. Breathwork can also energize and motivate positive change. '
  },
  {
    active: true,
    hasIntro: true,
    key: KEY_PRACTICE_COPING_SKILLS,
    lmsType: KEY_PRACTICE_COPING_SKILLS_WP,
    preferenceKey: KEY_PREFERENCE_COPING_SKILLS,
    title: 'Coping Skills',
    path: ROUTE_ACTIVITIES_COPINGSKILLS_ALL,
    image: CopingSkillsImage,
    why: {
      author: 'Jordan Green',
      bio: 'Jordan is an individual and couples therapist, creator of @the.love.therapist Instagram account, and founder of Remble.',
      title: 'Coping Skills',
      authorImage:
        'https://media-private.remble.com/wp-content/uploads/Jordan.png',
      subtitle:
        'Learn practical skills and get quick relief from uncomfortable feelings and tough issues. Or get Mia’s help to find strategies that work for you.',
      content:
        '<ul> <li>What are coping skills?</li> <li>The science of coping skills</li> <li>The benefits of coping skills</li> </ul>',
      videoURL:
        'https://media-private.remble.com/tutorials/videos/about_coping_skills.mp4',
      captionsURL:
        'https://media-private.remble.com/tutorials/captions/about_coping_skills_text.vtt'
    },
    description:
      'Coping skills are brief, single-session video-based activities that teach you how to handle life’s challenges confidently, like stopping a racing thought or overcoming anxiety or dread.'
  },
  {
    active: true,
    hasIntro: true,
    key: KEY_PRACTICE_MEDITATIONS,
    lmsType: KEY_PRACTICE_MEDITATIONS_WP,
    preferenceKey: KEY_PREFERENCE_MEDITATIONS,
    title: 'Meditations',
    path: ROUTE_ACTIVITIES_MEDITATION_ALL,
    image: MeditationImage,
    why: {
      author: 'Jordan Green',
      bio: 'Jordan is an individual and couples therapist, creator of @the.love.therapist Instagram account, and founder of Remble.',
      title: 'Meditations',
      authorImage:
        'https://media-private.remble.com/wp-content/uploads/Jordan.png',
      subtitle:
        'Guided and unguided meditations that induce deep relaxation, heightened awareness, emotional healing, and a tranquil mind. Or get Mia’s help to create your own.',
      content:
        '<ul> <li>What is meditation?</li> <li>The science of meditation</li> <li>The benefits of daily meditations</li> </ul>',
      videoURL:
        'https://media-private.remble.com/tutorials/videos/about_meditation.mp4',
      captionsURL:
        'https://media-private.remble.com/tutorials/captions/about_meditation_text.vtt'
    },
    description:
      'Meditation is a simple way to focus or clear your thoughts. Daily meditation calms, relaxes, and promotes well-being and happiness. Meditation is simple to learn and yields immediate effects. '
  },
  {
    active: true,
    key: KEY_PRACTICE_JOURNALING,
    lmsType: KEY_PRACTICE_JOURNALING_WP,
    preferenceKey: KEY_PREFERENCE_JOURNALING,
    title: 'Journaling',
    path: ROUTE_ACTIVITIES_JOURNALING_ALL,
    image: JournalingImage,
    why: {
      author: 'Jordan Green',
      bio: 'Jordan is an individual and couples therapist, creator of @the.love.therapist Instagram account, and founder of Remble.',
      title: 'Journaling',
      authorImage:
        'https://media-private.remble.com/wp-content/uploads/Jordan.png',
      subtitle:
        'Your private, encrypted, and digital Remble journal provides a safe place to examine difficult thoughts and feelings and find emotional healing. Or get Mia’s help to create your own prompts.',
      content:
        '<ul> <li>What is journaling?</li> <li>The science of journaling</li> <li>The benefits of daily journaling</li> </ul>',
      videoURL:
        'https://media-private.remble.com/tutorials/videos/about_journaling.mp4',
      captionsURL:
        'https://media-private.remble.com/tutorials/captions/about_journaling_text.vtt'
    },
    description:
      'Journaling helps you process challenging emotions and examine difficult thoughts. Your digital journal is a secure and encrypted record of your entries and is visible only to you.'
  },
  {
    active: true,
    key: KEY_PRACTICE_RELATIONSHIPQA,
    lmsType: KEY_PRACTICE_RELATIONSHIPQA_WP,
    preferenceKey: KEY_PREFERENCE_RELATIONSHIPQA,
    title: 'Relationship Conversations',
    path: ROUTE_ACTIVITIES_RELATIONSHIPQA_ALL,
    image: RelationshipQAImage,
    why: {
      author: 'Jordan Green',
      bio: 'Jordan is an individual and couples therapist, creator of @the.love.therapist Instagram account, and founder of Remble.',
      title: 'Relationship Conversations',
      authorImage:
        'https://media-private.remble.com/wp-content/uploads/Jordan.png',
      subtitle:
        'To thrive, couples need to build shared meaning. Use our hundreds of categorized relationship questions to spark meaningful conversations and bring you closer together. Or get Mia’s help to create your own.',
      content:
        '<ul> <li>What are relationship conversations?</li> <li>The science of relationsihp conversations</li> <li>The benefits of relationship conversations</li> </ul>',
      videoURL:
        'https://media-private.remble.com/tutorials/videos/about_relationship_converations_and_questions.mp4',
      captionsURL:
        'https://media-private.remble.com/tutorials/captions/about_relationship_converations_and_questions_text.vtt'
    },
    description:
      'Couples need a shared sense of purpose to thrive. Relationship Conversations help couples have meaningful talks on issues like sexual intimacy, parenting, finances, and expectations.'
  },
  {
    active: true,
    key: KEY_PRACTICE_COMPLIMENTS,
    lmsType: KEY_PRACTICE_COMPLIMENTS_WP,
    preferenceKey: KEY_PRACTICE_COMPLIMENTS,
    title: 'Compliments',
    path: ROUTE_ACTIVITIES_COMPLIMENTS_ALL,
    image: ComplimentsImage,
    why: {
      author: 'Jordan Green',
      bio: 'Jordan is an individual and couples therapist, creator of @the.love.therapist Instagram account, and founder of Remble.',
      title: 'Compliments',
      authorImage: '',
      subtitle:
        'Compliments for romantic partners, family, friends, and co-workers that make people feel valued. Or get Mia’s help to create your own.',
      content: '',
      videoURL: '',
      captionsURL: ''
    },
    description:
      'When you compliment a person, they feel seen and appreciated. We have hundreds of compliments for romantic partners, family, friends, and co-workers.'
  },
  {
    active: true,
    key: KEY_PRACTICE_DATE_IDEAS,
    lmsType: KEY_PRACTICE_DATE_IDEAS_WP,
    preferenceKey: KEY_PRACTICE_DATE_IDEAS,
    title: 'Date Ideas',
    path: ROUTE_ACTIVITIES_DATE_IDEAS_ALL,
    image: DateIdeasImage,
    why: {
      author: 'Jordan Green',
      bio: 'Jordan is an individual and couples therapist, creator of @the.love.therapist Instagram account, and founder of Remble.',
      title: 'Date Ideas',
      authorImage: '',
      subtitle:
        'Date ideas to enhance and refresh your relationship. Or get Mia’s help to come up with personalized ideas.',
      content: '',
      videoURL: '',
      captionsURL: ''
    },
    description:
      'When you schedule regular dates, your bond with your partner strengthens, and your relationship stays fresh. We have hundreds of date ideas to get you started.'
  }
]

export const notificationMessages = {
  [KEY_PRACTICE_AFFIRMATIONS]: [
    {
      title: 'Time to practice affirmations!',
      body: 'Repeating affirmations consistently programs your subconscious mind to become all you want to be.'
    },
    {
      title: 'Repeat your affirmation now!',
      body: 'Telling yourself what you want to achieve each day will stick in your mind and help you develop new habits to reach your goals.'
    },
    {
      title: 'Remember your affirmations',
      body: 'You are strengthening that pathway in your brain, making it easier to fall into that thought in the future.'
    },
    {
      title: 'Affirmation time!',
      body: 'Repeating your affirmations will bring you closer to the strong and confident person you want to be.'
    },
    {
      title: 'Time for your affirmations!',
      body: 'Affirmations help you to challenge negative and unhelpful thoughts.'
    },
    {
      title: 'Repeat your affirmations!',
      body: 'Even more powerful than the words you say to others are the words you say to yourself.'
    },
    {
      title: 'Remember to practice your affirmations',
      body: 'Watch your words, for they become actions.'
    },
    {
      title: 'Take a moment to practice your affirmations',
      body: 'Your thoughts will impact what you manifest in your life.'
    },
    {
      title: 'Time for affirmations!',
      body: 'Regular repetition of positive thoughts helps them to become your reality. '
    },
    {
      title: 'Repeat your affirmations!',
      body: 'Persistence and patience will help you quickly transform into a better and more optimistic person.'
    }
  ],
  [KEY_PRACTICE_BREATHWORK]: [
    {
      title: 'Time for breathwork!',
      body: 'Regular practice is the best way to make breathwork a healthy daily habit.'
    },
    {
      title: 'Remember breathwork!',
      body: 'It’s simple to make breathwork a healthy habit when you practice regularly.'
    },
    {
      title: 'Pause...take a breath',
      body: 'Your regular breathwork practice is helping you form a new healthy habit.'
    },
    {
      title: 'And...breathe',
      body: 'Controlled breathing during breathwork will dramatically affect your mental, emotional and physical well-being.'
    },
    {
      title: 'Take a breath',
      body: 'It’s time for breathwork. Breathwork will bring your body back into balance.'
    },
    {
      title: 'A breathwork reminder!',
      body: 'It’s time to experience renewed joy, peace of mind, and purpose. It’s time for your breathwork.'
    },
    {
      title: 'Take a deep breath',
      body: 'The best way to make breathwork a healthy daily habit is to do it often.'
    },
    {
      title: 'Time to do breathwork!',
      body: 'Breathwork is most effective when practiced regularly.'
    },
    {
      title: 'Time for breathwork!',
      body: 'Regular practice is the most effective approach to making breathwork a healthy habit.'
    },
    {
      title: 'Pause now for breathwork',
      body: 'With regular practice you return to wholeness and become better equipped to handle stress and anxiety.'
    },
    {
      title: 'Take a moment to breathe',
      body: 'Calm your body and mind with a few minutes of breathwork.'
    },
    {
      title: 'It’s time for breathwork!',
      body: 'Your breath can become the source of answers to questions  and freedom from feeling stuck.'
    },
    {
      title: 'It’s time! Time to breathe!',
      body: 'Focused breathing helps calm and slow down the emotional turbulence in your mind.'
    },
    {
      title: 'It’s time to breathe!',
      body: 'Ready to calm your mind and body? Take a moment to breathe. It only takes a few minutes to change how you feel.'
    }
  ],
  [KEY_PRACTICE_COPING_SKILLS]: [
    {
      title: 'Practice your coping skills!',
      body: 'In a busy and sometimes stressful life we all need good coping skills.'
    },
    {
      title: 'Time for skills practice',
      body: 'Ask yourself what is going on for you right now and what is stressing you. Good coping skills can help!'
    },
    {
      title: 'Remember your coping skills',
      body: 'When you need to take care of your feelings but circumstances are beyond your control, coping skills can help!'
    },
    {
      title: 'Remember coping skills!',
      body: 'Coping skills are healthy and effective ways to deal with situations that trouble you and build confidence that you can succeed.'
    },
    {
      title: 'Time to do your coping skill',
      body: 'When you use coping skills, you remember that you are in control and not helpless. You are someone who can cope!'
    },
    {
      title: 'Practice your coping skills!',
      body: 'The right coping skill often depends on the situation and your specific needs at that time.'
    },
    {
      title: 'Need to better cope?',
      body: 'The more skilled you are at coping, the more you will be ready to shape your life.'
    },
    {
      title: 'Work on those coping skills!',
      body: 'Having ways to deal with big and stressful challenges can help you keep a strong self-image and a healthy lifestyle.'
    },
    {
      title: 'Coping skills time!',
      body: 'What is it you want from a coping skill? Confidence? Problem-solving? Once you know what you want, you can learn a coping skill that will help.'
    }
  ],
  [KEY_PRACTICE_DAILY_REMBLE]: [
    {
      title: 'Keep your love strong',
      body: 'Relationships are a lifetime investment. Learn something new each day with the Daily Remble video! Start watching now!'
    },
    {
      title: 'Want relationship advice?',
      body: 'Watch the Daily Remble video for simple ideas to build solid relationships. Watch one now!'
    },
    {
      title: 'Grow your love!',
      body: 'Watch today’s Daily Remble video to get fresh advice on improving your relationships!'
    },
    {
      title: 'Strengthen your relationships!',
      body: 'Watch the Daily Remble video and learn little ways to improve your relationship from our experts!'
    },
    {
      title: 'Happy in your relationships?',
      body: 'You can have happier relationships by doing just a few little things each day. Watch the Daily Remble video for relationship tips!'
    },
    {
      title: 'How do relationships thrive?',
      body: 'It’s the little things. Watch today’s Daily Remble video and learn more.'
    },
    {
      title: 'Attain fulfilling relationships',
      body: 'Our Daily Remble videos advise you how to build happy, healthy relationships with quick, daily tips.'
    },
    {
      title: 'Realize great relationships!',
      body: 'Watch the Daily Remble video for relationship tips from our experts.'
    },
    {
      title: 'Boost your relationships!',
      body: 'Our Daily Remble videos have tips that will enhance all of your relationships.'
    },
    {
      title: 'Good relationships rock!',
      body: 'Our Daily Remble videos have tips that can propel your relationships to new heights!'
    }
  ],
  [KEY_PRACTICE_MEDITATIONS]: [
    {
      title: 'It’s time to meditate!',
      body: 'Regular practice is the best way to make meditation a healthy daily habit.'
    },
    {
      title: 'Remember to meditate!',
      body: 'It’s simple to create new habits when you practice regularly.'
    },
    {
      title: 'Pause now for meditation',
      body: 'Your regular practice will help you develop more emotional well-being and better health.'
    },
    {
      title: 'Time to breathe and focus',
      body: 'Time for your meditation practice.'
    },
    {
      title: 'Take a moment to meditate',
      body: 'When you meditate regularly, you’re creating a new healthy habit.'
    },
    {
      title: 'It’s time to meditate!',
      body: 'Regular meditation is your path to joy, peace of mind, and purpose.'
    },
    {
      title: 'Pause to meditate',
      body: 'The best way to make meditation a healthy daily habit is to do it regularly and often.'
    },
    {
      title: 'It’s time for you to meditate!',
      body: 'Meditation is most effective when practiced regularly.'
    },
    {
      title: 'It’s meditation time!',
      body: 'Regular practice is the most effective way to make meditation a healthy habit.'
    },
    {
      title: 'Your meditation reminder',
      body: 'The easiest way to turn your practice into a routine is to make meditation a regular part of your day.'
    }
  ],
  [KEY_PRACTICE_JOURNALING]: [
    {
      title: 'It’s time to journal',
      body: 'Journaling is a healthy way to deal with overwhelming emotions and find a good way to express yourself.'
    },
    {
      title: 'It’s journaling time!',
      body: 'Journaling is one of the most potent self-improvement activities, and it’s right at your fingertips.'
    },
    {
      title: 'Remember your journaling!',
      body: 'Journaling helps you grow, become more self-aware and gain meaningful insights.'
    },
    {
      title: 'Your journaling reminder!',
      body: 'Stick to it and you’ll soon see the positive outcomes of journaling in your personal and professional life.'
    },
    {
      title: 'Start writing!',
      body: 'Science proves that journaling your goals helps you visualize them more clearly, taking you one step closer to achieving them.'
    },
    {
      title: 'Take a moment to journal',
      body: 'Regular journaling can lead to insights and breakthroughs and help you process difficult emotions and situations.'
    },
    {
      title: 'Reminding you to journal!',
      body: 'There’s no right or wrong way to journal. Just leave your inner critic ‘at the door’ and write.'
    },
    {
      title: 'Time to work on that journal!',
      body: 'Creating a writing routine and scheduling journaling time can help you stay on track, even when you feel uninspired.'
    },
    {
      title: 'Continue your journaling!',
      body: 'When it comes to what you want to write about, the possibilities are limitless.'
    },
    {
      title: 'Journaling time!',
      body: 'When everything around you seems chaotic, keeping a journal can help create order and find peace.'
    }
  ],
  [KEY_PRACTICE_RELATIONSHIPQA]: [
    {
      title: 'How’s your talking going?',
      body: 'It’s time to do what the happiest and most strongly connected couples do. It’s time for a relationship conversation!'
    },
    {
      title: 'Time for a good conversation',
      body: 'Talking, being heard, and better understanding yourselves strengthens your connection.'
    },
    {
      title: 'Good talks are the best!',
      body: 'Remember to share something with your partner today and learn to better understand one another. Have a great relationship conversation!'
    },
    {
      title: 'Go beyond small talk!',
      body: 'Talk meaningfully with your partner today and explore a topic you haven’t discussed before.'
    },
    {
      title: 'Time to talk!',
      body: 'Have you had a loving conversation today?'
    },
    {
      title: 'It’s time for a great talk',
      body: 'Learn something new, meaningful, and valuable about each other and your relationship!'
    },
    {
      title: 'Talk meaningfully today!',
      body: 'Explore a new topic with your partner.'
    },
    {
      title: 'Time to talk!',
      body: 'Go beyond small talk. Discuss something that deepens your bond.'
    },
    {
      title: 'Remember to talk!',
      body: 'Talking with your partner about something meaningful brings you closer together.'
    },
    {
      title: 'It’s relationship talk time!',
      body: 'There’s always something new to learn about the people you love.'
    }
  ]
}

// Confirmation text closing statements
export const closingStatements = [
  'Now that you’ve completed the session and enhanced your knowledge, it’s time to put your new learning into action in your everyday life. With small steps will come big change!',
  'To transform your new knowledge into skills, you should immediately apply what you learned in your everyday life.',
  'To ensure you get the most out of what you learned and achieve the change you want, think now about how you can put your experience to work in a meaningful manner right away.',
  'To make real change happen, this session was just the beginning of the work you should do. Your next step is to apply this learning to your life!',
  'This session is only the beginning of the effort you need to bring about meaningful change. Your next step is to put this knowledge to use in your daily life!'
]

// Meditation audio sounds
export const meditationSounds = {
  'Celestial Beauty':
    'https://media-private.remble.com/practices/meditations/music/Celestial_Beauty_Loop_60.mp3',
  'Healing Piano':
    'https://media-private.remble.com/practices/meditations/music/Healing_Piano_Loop_60.mp3',
  'If You Just Believe':
    'https://media-private.remble.com/practices/meditations/music/If_You_Just_Believe_Loop_60.mp3',
  'Meditation Yoga':
    'https://media-private.remble.com/practices/meditations/music/Meditation_Yoga_Ping2_60.mp3',
  'Spiritual Om Chant':
    'https://media-private.remble.com/practices/meditations/music/Spiritual_Om_Chant_Loop_60_v2.mp3',
  'Urban Rain':
    'https://media-private.remble.com/practices/meditations/music/Urban_Rain_Stereo_Ambiance_60.mp3'
}

export const generativeFeatures = [
  {
    slug: 'open',
    icon: 'chat-dots',
    title: 'Chat with Mia',
    subtitle:
      'Chat anonymously with Mia to ask questions and discuss mental health and well-being',
    prompt: username => 'Hello ' + username + '. How can I help you today?',
    tips: ''
  },
  {
    slug: 'symptoms-identification',
    icon: 'clipboard-pulse',
    title: 'Symptom Identifier',
    subtitle:
      'Ask Mia about about signs and symptoms you have and what they may mean',
    prompt: username =>
      'Hello ' +
      username +
      '. \n\nI’m here to help you determine if any changes you’re experiencing may be signs of a mental health condition. Please describe the signs or symptoms in detail, including their frequency, intensity, and any factors that worsen or improve them. If you have any relevant past history with a condition, please mention it.',
    example:
      'For example, you could say, “Sometimes my heart starts pounding rapidly, and I struggle to catch my breath. I have difficulty thinking clearly, and these episodes last about five or ten minutes. My father also had similar attacks. What could this indicate?”\n\nRemember, while I can provide information and guidance, I cannot provide a formal diagnosis. It’s best to consult with a qualified healthcare professional for a comprehensive evaluation.',
    tips: `
    <ul>
      <li>Be specific: Use specific words related to your symptoms (e.g. instead of “back pain” say “upper back pain” or “lower back pain”).</li>
      <li>Do not self-diagnose: Remember that mental health symptoms can have multiple causes and a mental health professional should always confirm a diagnosis.</li>
    </ul>
  `
  },
  {
    slug: 'create',
    icon: 'file-text',
    title: 'Therapeutic Activities Creator',
    subtitle:
      'Ask Mia to create personalized and tailored journal prompts, affirmations, meditations, couples communication strategies, date ideas, and more',
    prompt: username =>
      'Hello ' +
      username +
      '. \n\nI’m here to assist you in creating personalized journal prompts, affirmations, meditations, couples communication activities, and date ideas. Please let me know which type of activity you would like me to generate for you and provide specific details on how you want it personalized. Consider aspects such as your desired outcomes, preferences, and circumstances. The more specific you are, the better I can tailor the activity to your needs. If the initial result doesn’t fully meet your expectations, please let me know what changes you would like, and I’ll make the necessary adjustments.',
    example:
      'For example, you could say, "I would like a five-minute meditation script to help me relax and slow down my breathing. I want it to help me reduce excessive worrying. I enjoy sounds of nature like birds and wind in the trees but please not water sounds. Please include instructions on how often I should practice this meditation and steps to help me establish it as a habit."',
    tips: `
    <ul>
      <li>Be specific and provide as much detail as possible. For example, the length of meditation and types of imagery, your date night budget, the number of journal prompts, the areas you want to improve with affirmations.</li>
      <li>Consider your goals and state what you want to achieve. </li>
      <li>Provide feedback to help Mia refine and improve the response. </li>
    </ul>
  `
  },
  {
    slug: 'coping-strategies',
    icon: 'search-heart',
    title: 'Coping Techniques and Strategies Finder',
    subtitle:
      'Find effective coping strategies and techniques to boost your overall well-being, effectively manage mental health symptoms, and cultivate healthy habits',
    prompt: username =>
      'Hello ' +
      username +
      '. \n\nI’m here to assist you in finding therapeutic techniques and activities that can support your mental health and well-being. To get started, please let me know what specific area you need help with or type of activity you’re looking for. Feel free to provide any relevant details to ensure a more personalized recommendation.',
    example:
      'For example, you could say, "I have an extreme phobia of dogs, and even the thought of them upsets me. I’m looking for an activity that can help me overcome this fear. Could you suggest something and guide me through the steps to complete it?” \n\nBased on your input, I’ll provide you with a suitable therapeutic activity or technique. Whether it’s a breathing exercise for relaxation, a method to monitor changes in your mood, or guidance on stopping worry and cultivating positive thinking, I’ll give you clear instructions on how the activity works',
    tips: `
    <ul>
      <li>Be specific and provide as much detail as possible about the problem you want help with.</li>
      <li>Consider your goals (what you want to achieve, change, improve, reduce, or stop).</li>
      <li>Provide feedback on what you liked and did not like and ask for an improved suggestion. </li>
    </ul>
  `
  },
  {
    slug: 'education',
    icon: 'book',
    title: 'Mental Health Educator',
    subtitle: 'Learn about therapeutic concepts, theories, and techniques',
    prompt: username =>
      'Hello ' +
      username +
      '. \n\nI’m here to help you understand various types of therapy, principles, and concepts by providing straightforward and easily understandable explanations. If there’s a specific concept you’d like me to explain, let me know, and also share your current level of understanding of the topic. If my initial explanation isn’t clear enough feel free to ask me to break it down into smaller, simpler pieces. Don’t hesitate to ask follow-up questions if anything remains unclear.',
    example:
      'For example, you could say, "I’m interested in learning more about cognitive distortions and their impact on my mental health. Can you give me a basic explanation of what cognitive distortions are, how they develop, and provide some examples of common cognitive distortions? Please use simple language that’s easy to understand."',
    tips: `
    <ul>
      <li>Be specific about the therapy concept or technique. If you know the exact name or term, state it and put it in quotation marks.</li>
      <li>Request analogies, examples or visual aids to help you better grasp the idea.</li>
      <li>Request further reading and ask follow-up questions if you're interested in learning more.</li>
      <li>Request further simplification if needed.</li>
    </ul>
  `
  },
  {
    slug: 'motivation',
    icon: 'lightbulb',
    title: 'Mood and Confidence Booster',
    subtitle:
      'Ask Mia to give you uplifting content to boost your mood, including encouragement, affirmations, quotes, and activities',
    prompt: username =>
      'Hello ' +
      username +
      '. \n\nI’m here to assist you in improving your mood and boosting your confidence to help you achieve your goals. Whether you’re seeking an immediate uplift or a long-term strategy, I can provide personalized suggestions. Please let me know what areas you would like to feel more positive and hopeful about, and provide some context about your journey so far. Feel free to share what has been working well for you and the challenges you are currently facing. Additionally, if you’re interested, you can ask me about specific strategies or techniques that have been successful for others in similar situations.',
    example:
      'For example, you could say, "Please write five affirmations that will boost my confidence and help me feel more energized and self-assured. Also, include instructions on how I can use these affirmations for the best results.”',
    tips: `
    <ul>
      <li>Provide as much detail as possible about what kind of uplifting content you're looking for. This can include the type of encouragement you need, the specific affirmations that would be helpful to you, the type of quotes that resonate with you, and the self-care activities that you enjoy.</li>
      <li>Focus on positive self-talk and ask for language that empowers you and reminds you of your strengths and capabilities.</li>
      <li>Ask for suggestions for visualization techniques that can help you focus on outcomes that you want to achieve.</li>
      <li>Request a mix of activities. This can include exercises that increase mindfulness, movement or exercise routines that you enjoy, or other activities that make you feel good about yourself.</li>
      <li>Ask to keep it simple and easy to incorporate into your daily routine.</li>
    </ul>
  `
  },
  {
    slug: 'change-partner',
    icon: 'person-check',
    title: 'Your Virtual Change Partner',
    subtitle: 'Changing your thinking and habits of living can be hard ',
    prompt: username =>
      'Hello ' +
      username +
      '. \n\nIf you’re finding it challenging to make changes in your life, I’m here to offer support as your personal change partner. Please share your personal change goals, the specific change you are trying to make, and the steps you have already taken towards those goals. Additionally, let me know what type of support you need. Are you seeking accountability partners to help you stay on track, or do you need motivation and encouragement during moments of discouragement?',
    example:
      'For example, you could say, “Currently, I’m working on building my self-confidence and managing my anxiety through therapy. However, I’m feeling a bit stuck and could use some encouragement and motivation to keep going. Can you provide me with personalized strategies and affirmations that can help me stay on track and achieve my goals?”',
    tips: `
    <ul>
      <li>Be specific and provide as much detail as possible about the specific area in which you need encouragement and motivation. This can include the challenges you're facing in therapy, the specific self-change efforts you're working on, or the areas where you need the most support.</li>
      <li>Share your progress: Keep me informed about your progress in therapy and self-change efforts. Sharing your achievements and milestones can help me provide more targeted and effective encouragement.</li>
      <li>Focus on positive self-talk. Ask for language that empowers you and reminds you of your strengths and capabilities.</li>
      <li>Be open to new ideas and approaches that you may not have considered before.</li>
    </ul>
  `
  }
]

export const JOURNALING_ACTIVITY = 'journaling_activity'
export const BREATHING_ACTIVITY = 'breathing_activity'
export const MEDITATION_ACTIVITY = 'meditation_activity'
export const COPING_ACTIVITY = 'coping_activity'
export const AFFIRMATION_ACTIVITY = 'affirmation_activity'

export const CATEGORIES_WHITE_LIST = {
  'Addiction': [
    'Alcohol/Drug',
    'Technology',
    'Sex',
    'Gambling',
    'Recovery',
  ],
  'Anxiety':[
    'Generalized',
    'Managing Anxiety',
    'OCD',
    'Panic/Agoraphobia',
    'Perfectionism',
    'Phobias',
    'Social',
  ],
  'Depression': [
    'Bipolar',
    'Major Depression',
    'Managing Depression',
    'Postpartum',
  ],
  'Trauma/PTSD': [],
  'Psychosis/Schizophrenia': [],
  'Eating Disorders': [],
  'Manage Mood': [
    'Anger',
    'Fear',
    'Grief',
    'Loneliness',
    'Sadness',
    'Jealousy/Envy',
  ],
  'Self-Development': [
    'Changing Thinking',
    'Self-Esteem',
    'Values/Goals',
  ],
  'Calm/Mindfulness': [
    'Affirmations',
    'Breathwork',
    'Gratitude',
    'Journaling',
    'Meditation/Mindfulness',
    'Relaxation Skills',
  ],
  'Relationships': [
    'Communication Skills',
    'Dating/New',
    'Divorce/Separation',
    'Friendships/Support',
    'Improving/Enhancing',
    'Intimacy/Sex',
    'Resolving Conflict',
  ],
  'Family/Parent': [
    'ADHD',
    'Household',
    'Parenting skills',
  ],
  'Wellness': [
    'Healthy Habits',
    'Resilience',
    'Sleep',
    'Stress',
  ]
}

export const PARENT_CATEGORIES = Object.keys(CATEGORIES_WHITE_LIST).map(t => t.toLowerCase())
